var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#121331",
    strokeLinecap: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30 100c0-11.046 8.954-20 20-20h330c11.046 0 20 8.954 20 20v230c0 11.046-8.954 20-20 20H50c-11.046 0-20-8.954-20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M70 120h70v70H70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 270h50m30 0h50m30 0h50m30 0h50M70 310h130"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M346.304 120c19.33 19.33 19.33 50.67 0 70M325 141.304c7.564 7.564 7.564 19.828 0 27.392"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.11b3e3f8d09d21282b59d69bc3fe2f6d.svg";
export { ForwardRef as ReactComponent };